import axios from 'axios';
import React from 'react'
import { baseUrl } from '../../config/clientsConfig';

const leaveRequestService = {
    getLeaveRequestList : async (body) => {
        return await axios.post(`${baseUrl}/leaves/list`, body);
    },
    actionApproveLeaveRequest : async (body) => {
        return await axios.put(`${baseUrl}/leaves/approval`, body);
    },
    leaveRequestCount : async () => {
        return await axios.get(`${baseUrl}/leaves/counts`, );
    }
}
export default leaveRequestService